<template>
  <div class="flow">
    <div class="aside">
      <div class="title">
        <i class="icon icon-yonghu2"></i>
        <span v-if="type === 'add'">{{ $t('base_processItem.xin_jian_liu_cheng') }}</span>
        <span v-if="type === 'edit'">{{ $t('base_processItem.bian_ji_liu_cheng') }}</span>
      </div>
      <t-step
        v-model="step"
        :list="stepList"
        @step="onStepChange"
      ></t-step>
    </div>
    <div class="section">
      <!-- 基础信息 -->
      <item-base
        v-if="step === 1 && type"
        @next="onNext"
        @create="onCreate"
        @save="onSave"
        @cancel="onCancel"
        :workflowId="workflowId"
      ></item-base>
      <!-- 流程管理 -->
      <item-param
        v-if="step === 2 && type"
        @prev="onPrev"
        @cancel="onCancel"
        :workflowId="workflowId"
        :type="type"
      ></item-param>
    </div>
  </div>
</template>

<script>
import tStep from '@/components/step.vue';
import itemBase from './children/process_item_base';
import itemParam from './children/process_item_param';


export default {
  components: {
    tStep,
    itemBase,
    itemParam
  },
  computed: {
    stepList() {
      return [
        {
          label: 1,
          value: 1,
          title: this.$t('base_processItem.ji_chu_xin_xi'),
          subTitle: this.$t('base_processItem.cpjbxxtx')
        },
        {
          label: 2,
          value: 2,
          title: this.$t('base_processItem.liu_cheng_guan_li'),
          subTitle: this.$t('base_processItem.szlcdcs')
        }
      ];
    }
  },
  data() {
    return {
      provide: true,
      step: 1,
      type: '',
      workflowId: ''
    };
  },
  methods: {
    onStepChange(step) {
      if (this.type === 'edit') {
        this.step = step;
      }
    },
    onNext() {
      this.step++;
      this.clearKeepAlive('approvalProcess');
    },
    onPrev() {
      this.step--;
    },
    onCancel() {
      this.clearTagByKeep('processItem');
      this.jump('/examine/approvalProcess', {}, true);
    },
    onCreate(data) {
      this.workflowId = data.workflowId;
    },
    onSave(data) {
      this.workflowId = data.workflowId;
    }
  },
  mounted() {
    const workflowId = this.getJump('workflowId');
    this.workflowId = workflowId;
    this.type = workflowId ? 'edit' : 'add';
  }
};
</script>

<style></style>
